import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl + '/tradeReport'
export default {
    list(params) {
        return request({
            url: BASE_URL + '/fourList',
            method: 'get',
            params
        })
    },
    exportExcel(params) {
        return request({
            url: BASE_URL + '/exportFourExcel',
            method: 'get',
            responseType: 'blob',
            params
        })
    },
}